
import { singularityStore } from "@/store/store";
import {
  checkForClaimKeyInUrl,
  cleanupClaimKeyFromUrl,
  handleClaimKeyOnLoad
} from "@/futurelayer/connector/connector";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TopNavNotificationBarDeletionWarning from "./TopNavNotificationBarDeletionWarning.vue";
import TopNavNotificationBarConnectSite from "./TopNavNotificationBarConnectSite.vue";
import TopNavNotificationBarSuccess from "./TopNavNotificationBarSuccess.vue";

@Component({
  components: {
    TopNavNotificationBarDeletionWarning,
    TopNavNotificationBarConnectSite,
    TopNavNotificationBarSuccess
  }
})
export default class TopNavNotificationBar extends Vue {
  get hasExpiration(): boolean {
    const siteState = singularityStore.siteStatus.siteState;
    if (!siteState || 'error' in siteState) return false;
    return siteState.expiration !== null && siteState.expiration !== undefined;
  }

  get isSelfHostedAndUnclaimed() {
    return !this.hasExpiration && !this.isClaimed;
  }
  get isOnInstaWPAndUnclaimed(): boolean {
    return this.hasExpiration && !this.isClaimed;
  }

  get isClaimed(): boolean {
    return singularityStore.siteStatus.isClaimed;
  }

  get showClaimSuccess() {
    return this.isClaimed && this.hasClaimKeyInUrl;
  }

  hasClaimKeyInUrl = false;
  claimInProgress = false;
  async mounted() {
    this.hasClaimKeyInUrl = checkForClaimKeyInUrl() !== null;

    if (this.hasClaimKeyInUrl) {
      this.claimInProgress = true;
      await handleClaimKeyOnLoad();
      this.claimInProgress = false;
    }
  }

  handleDismiss() {
    cleanupClaimKeyFromUrl();
    this.hasClaimKeyInUrl = false;
  }
}
